import { useMutation } from '@tanstack/react-query';

import { AllowListItemFormSchemaValues } from 'src/features/allowList/utils/formSchema';
import { AllowListItem } from 'src/features/allowList/utils/types';
import axios from 'src/lib/axios';
import { MutationConfig } from 'src/lib/react-query';
import { GeneralSmartParkError } from 'src/registry/types/axios';
import { formatResourcePath } from 'src/utils/regex';

const RESOURCE = 'sp-core/:parkingId/allow-lists/allow-list/:listId/allow-list-items/';

type MutationFnType = typeof mutationFn;

interface DTO {
    data: AllowListItemFormSchemaValues;
    listId: string;
    parkingId: string;
}
const mutationFn = ({ listId, data, parkingId }: DTO): Promise<AllowListItem> => {
    return axios.post(formatResourcePath(RESOURCE, { parkingId, listId }), data);
};

const useMutationHook = (options: MutationConfig<MutationFnType, GeneralSmartParkError>) =>
    useMutation({
        mutationFn,
        ...options,
    });

export { useMutationHook as useCreateAllowListItem };
